import { QueryResult, useQuery } from '@apollo/client'
import { GET_CAREER_PATH } from '../CareerPathQueries'
import { GetCareerPathQuery, GetCareerPathQueryVariables, Country } from '../../../types'

export const useGetCareerPathData = (country: Country): QueryResult<GetCareerPathQuery, GetCareerPathQueryVariables> => {
  return useQuery<GetCareerPathQuery, GetCareerPathQueryVariables>(GET_CAREER_PATH, { variables: { country } })
}
